import { useMemo } from 'react'

import { parsePlgTestsFromCookie } from '@core/abTesting/abTesting'
import { decodeABTestCookiePayload } from '@core/abTesting/cookiePayload'
import { ABTestID } from '@core/abTesting/types'
import { getCookie } from '@core/storage'
import { StorageKeyPerformanceEnum } from '@core/storage/types'

/**
 * Returns boolean representing whether visitor is in PLG control group, based on cookie
 * Cookie contains a value shaped like { tests: string } (JSON-serialized TrackingTest[])
 */
export const useIsFivePercentControlGroup = () => {
  return useMemo(() => {
    const cookie = getCookie(StorageKeyPerformanceEnum.fw_abt)
    if (cookie) {
      try {
        const parsed = JSON.parse(decodeABTestCookiePayload(cookie))
        const test = parsePlgTestsFromCookie(parsed?.tests).find(
          (test) =>
            test.id === ABTestID.NINETY_FIVE_PERCENT_TRAFFIC_WIDGET_DISPLAY,
        )
        return test?.variant === 'invisible'
      } catch {}
    }
    return false
  }, [])
}
